import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=41f73b6b&scoped=true"
import script from "./index2.vue?vue&type=script&lang=ts"
export * from "./index2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f73b6b",
  null
  
)

export default component.exports